<template>
  <v-autocomplete
    v-model="selectedWorkspace"
    :search-input="search"
    label="Rechercher un Workspace"
    class="workspace-search-bar"
    clearable
    :items="filteredWorkspaces"
    item-text="name"
    color="info"
    prepend-inner-icon="search"
    return-object
    menu-props="light"
    @change="onWorkspaceSelected"
  >
    <template #item="{ item }">
      <v-list-item-icon v-if="isAlpha" class="my-auto ml-0 mr-2"><v-icon :color="item.settings && item.settings.siteSettings && item.settings.siteSettings.robotsIndex ? 'green' : 'red'">fiber_manual_record</v-icon></v-list-item-icon>
      <v-list-item-title>{{ item.name }}</v-list-item-title>
    </template>
  </v-autocomplete>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import { useRoute } from 'vue2-helpers/vue-router';

import { changeWorkspace } from '@/utils/pwa';

const route = useRoute();
const store = useStore();
const workspaces = computed(() => store.getters.liveWorkspaces);
const selectedWorkspace = ref(null);
const search = ref('');

const isAlpha = computed(() => store.state.environment.PROJECT === 'alpha');

const filteredWorkspaces = computed(() => {
  if (search.value) {
    return workspaces.value.filter(workspace => workspace.name.toLowerCase().includes(search.value.toLowerCase()));
  }
  return workspaces.value;
});

const onWorkspaceSelected = () => {
  changeWorkspace(selectedWorkspace.value, route);
  nextTick(() => {
    search.value = '';
    selectedWorkspace.value = null;
  });
};

</script>

<style scoped>
.workspace-search-bar {
  margin-top: 25px !important;
  width: 100%;
}

.workspace-search-bar > .v-input__control {

}
</style>
